import React, { useEffect, useMemo } from "react";
import { IonPage, IonContent, IonImg, IonRow } from "@ionic/react";
import DealHeader from "../components/DealHeader";
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../store";
import { bindActionCreators } from "redux";
import * as HeaderFooterStore from '../store/HeaderFooterStore';
import './DealSummaryPage.scss';
import { formatCurrency } from "../helpers/currencyHelpers";
import { useHistory } from "react-router";
import { showDealHeader, shouldShowModifierGroup, getSelectedSkus, inlineBrandImage } from "../helpers/menuHelpers";
import { baseUrl, cacheBust } from "../helpers/configHelper";

function DealSummaryPage() {
    const dispatch = useDispatch();
    const history = useHistory();

    const menuItem = useSelector((state: ApplicationState) => state.menuItemData?.menuItem);
    const isColleague = useSelector((state: ApplicationState) => state.colleague?.isLoggedIn);

    const setTitle = bindActionCreators(HeaderFooterStore.actionCreators.setTitle, dispatch);

    const selectedSkus = useMemo(() => {
        if (!menuItem?.modifierGroups) {
            return [];
        }

        return getSelectedSkus(menuItem.modifierGroups);
    }, [menuItem?.modifierGroups])

    useEffect(() => {
        if (!menuItem) {
            return;
        }

        const title = menuItem.menuItemName.replace(/\[\[.*\]\]/, '')
        setTitle(title, true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [menuItem])

    return (
        <IonPage>
            <IonContent fullscreen>
                {menuItem &&
                    <>
                        {showDealHeader(menuItem, isColleague)
                            ?
                            <DealHeader
                                menuItem={menuItem}
                            />
                            :
                            <IonRow>
                                <IonImg
                                    className="deal-product-image"
                                    src={`${baseUrl()}/images/ProductShots/${menuItem.sku}_PDP.png?v=${cacheBust()}`}
                                />
                            </IonRow>
                        }
                        <div className='deal-summary-page'>
                            <h2>{showDealHeader(menuItem, isColleague) ? 'Your deal' : 'Your summary'}</h2>
                            <h2
                                className='primary'
                                onClick={() => history.goBack()}
                            >
                                Press Back to make changes
                            </h2>

                            <p className='flex'>
                                <strong dangerouslySetInnerHTML={{__html: inlineBrandImage(menuItem.menuItemName, menuItem.hasBrandImage)}}></strong>
                                <strong className='right'>{formatCurrency(menuItem.menuItemBasePrice)}</strong>
                            </p>

                            {menuItem.modifierGroups
                                .filter((group: IMopModifierGroup) => {
                                    return shouldShowModifierGroup(group, selectedSkus, menuItem.sku)
                                })
                                .map((group: IMopModifierGroup) => {
                                    const isChargeable = group.itemsAreChargeable;
                                    return (
                                        <>
                                            {group.modifierGroupItems.map((item: IMopModifierGroupItem) => {
                                                return [...Array(item.quantitySelected)].map((e, i) => {
                                                    return (
                                                        <p className='flex'>
                                                            <span>
                                                                {isChargeable &&
                                                                    <span>+ </span>
                                                                }
                                                                <span dangerouslySetInnerHTML={{ __html: inlineBrandImage(item.menuItemName, item.hasBrandImage) }}></span>
                                                            </span>
                                                            {isChargeable &&
                                                                <strong className='right'>{formatCurrency(item.price)}</strong>
                                                            }
                                                        </p>
                                                    )
                                                })
                                            })}
                                        </>
                                    )
                                })}

                            <p className='flex'>
                                <strong>Total</strong>
                                <strong className='right'>{formatCurrency(menuItem.menuItemTotalPrice)}</strong>
                            </p>
                        </div>
                    </>
                }
            </IonContent>
        </IonPage>
    );
}

export default DealSummaryPage;
